import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ModalModule } from 'ngx-bootstrap/modal';

import {
  NgbModalModule,
  NgbTooltipModule,
  NgbProgressbarModule,
  NgbDatepickerModule,
  NgbPopoverModule,
  NgbDropdownModule,
  NgbAlertModule} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    NgbModalModule,
    NgbTooltipModule,
    NgbProgressbarModule,
    NgbDatepickerModule,
    NgbPopoverModule,
    NgbDropdownModule,
    NgbAlertModule,
  ],
  declarations: [],
  exports: [
    ModalModule,
    NgbModalModule,
    NgbTooltipModule,
    NgbProgressbarModule,
    NgbDatepickerModule,
    NgbPopoverModule,
    NgbDropdownModule,
    NgbAlertModule,
  ]
})
export class BootstrapModule { }
